export class SaveManagementUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(managementValues){
    const resp=await this.repository.save(managementValues)
    return resp
  }
}
